import {
  TRANSACTIONS_DECLINED_DEFINITIONS_FAILURE,
  TRANSACTIONS_DECLINED_DEFINITIONS_REQUEST,
  TRANSACTIONS_DECLINED_DEFINITIONS_SUCCESS,
} from '../actions/transactions_decline_definitions'

export const fetchTransactionsDeclineDefinitions = (
  state = {
    isFetching: false,
    data: [],
    errorMessage: null,
    count: 0,
    requestUrl: '',
  },
  action
) => {
  switch (action.type) {
    case TRANSACTIONS_DECLINED_DEFINITIONS_REQUEST:
      return {
        ...state,
        data: [],
        isFetching: true,
        errorMessage: null,
        count: 0,
        requestUrl: '',
      }
    case TRANSACTIONS_DECLINED_DEFINITIONS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        data: action.response.results,
        count: action.response.count,
        requestUrl: action.requestUrl,
      }
    case TRANSACTIONS_DECLINED_DEFINITIONS_FAILURE:
      return {
        ...state,
        errors: null,
        data: [],
        isFetching: false,
        errorMessage: action.error,
        count: 0,
        requestUrl: action.requestUrl,
      }
    default:
      return state
  }
}
